export default __webpack_public_path__ + "static/media/gallery (4).59486e8a.png";